import { styled } from '@linaria/react';
import { ButtonHTMLAttributes, ReactNode } from 'react';

import { uiToken } from '~/shared/constants/uiToken';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  active?: boolean;
  className?: string;
};

export const Root = styled.button<ButtonProps>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #ffffff;
  background: ${({ active }) =>
    active ? '#1E2741' : uiToken.color.background.secondary};

  border: 4px solid ${({ active }) => (active ? '#5B82FF' : 'transparent')};

  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${uiToken.color.border.glassActive};
    outline-offset: 2px;
  }

  &::after {
    content: '';
    position: absolute;
    inset: -3px;
    border-radius: 4px;
    pointer-events: none;
    border: ${({ active }) =>
      active ? 'none' : `0.5px solid ${uiToken.color.border.default}`};
  }
`;
